import LocationsNewLocationDetails from "@/Shared/Locations/CustomComponents/LocationsNewLocationDetails";
import { warningMessagesForDeliveryLocation } from "@/Shared/Locations/Validators/locationsErrorMessagesForDeliveryLocation";
import { locationsErrorMessagesForLocation } from "@/Shared/Locations/Validators/locationsErrorMessagesForLocation";
import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface DeliveryDetailsPageProp {
  shipment: Shipment;
}

export function ModifyShipmentDeliveryDetailsPage(
  props: DeliveryDetailsPageProp,
) {
  const errorMessages = locationsErrorMessagesForLocation(
    props.shipment.deliveryLocation,
    false,
  );
  const warningMessages = warningMessagesForDeliveryLocation(
    props.shipment.pickupLocation,
    props.shipment.deliveryLocation,
  );

  return (
    <LocationsNewLocationDetails
      locationErrorMessages={errorMessages}
      locationWarningMessages={warningMessages}
      context={LocationContext.Delivery}
      setLocation={() => {}}
      location={props.shipment.deliveryLocation}
      forceValidation={false}
      disablePostalCodeEntry={false}
      pickupDate={props.shipment.pickupDate}
    />
  );
}
